<template>
  <ApolloQuery
    :query="
      (gql) => gql`
        query LoggedInStripeAccount {
          getLoggedInUser {
            id
            stripeAccount {
              id
              chargesEnabled
            }
          }
        }
      `
    "
    @result="
      (result) => {
        update(result.data);
      }
    "
  >
    <template v-slot="{ result: { data } }">
      <h3 class="housekeeping__title mb-5" v-if="setupRequired(data)">
        {{ $t("becomeACreator.houseKeeping.finishSettingUpCreatorAccount") }}
      </h3>
      <v-row>
        <v-col md="4" xs="12" v-if="user && user.isVerified == false">
          <StoryCitySolidButton
            x-large
            color="secondary"
            :to="{ name: 'verify-email' }"
          >
            {{ $t("register.verification.verifyYourEmail") }}
          </StoryCitySolidButton>
        </v-col>
        <v-col
          md="4"
          xs="12"
          v-if="setupRequired(data)"
        >
          <StoryCitySolidButton
            x-large
            :to="{ name: 'banking' }"
            v-if="needToCreateAccount(data)"
          >
            {{ $t("becomeACreator.houseKeeping.connectYourBankAccount") }}
          </StoryCitySolidButton>
          <StoryCitySolidButton
            x-large
            :to="{ name: 'banking' }"
            v-else-if="needToFinishAccountSetup(data)"
          >
          {{ $t("becomeACreator.houseKeeping.finishSettingUpYourBankAccount") }}
          </StoryCitySolidButton>
        </v-col>
      </v-row>
    </template>
  </ApolloQuery>
</template>
<script>
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import StoryCitySolidButton from "../Buttons/StoryCitySolidButton.vue";
export default {
  mixins: [hasLoggedInUser],
  components: { StoryCitySolidButton },
  methods: {
    update(data) {
      if (this.setupRequired(data)) {
        return this.$emit("visible", true);
      }
      return this.$emit("visible", false);
    },
    needToCreateAccount(data) {
      if (data?.getLoggedInUser && !data.getLoggedInUser.stripeAccount) {
        return true;
      }
      return false;
    },
    needToFinishAccountSetup(data) {
      return !!data?.getLoggedInUser?.stripeAccount?.chargesEnabled === false;
    },
    setupRequired(data) {
      return (
        this.needToCreateAccount(data) ||
        this.needToFinishAccountSetup(data) ||
        (this.user && this.user.isVerified == false)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.housekeeping__title {
  color: var(--v-textOnAccent-base);
  font-size: 26px;
  font-weight: 600;
}
</style>
